class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector("sticky-header");
    this.drawer = document.querySelector("cart-drawer");
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    this.startAnimationLoop();
  }

  disconnectedCallback() {
    // Clean up the animation loop when the element is removed from the DOM
    this.stopAnimationLoop();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("mini-cart").innerHTML =
          this.getSectionInnerHTML(html, ".shopify-section");

        document.dispatchEvent(new CustomEvent("cartdrawer:opened"));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector("details");
    if (detailsElement.hasAttribute("open")) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  startAnimationLoop() {
    const self = this; // Store a reference to "this" for use inside the animation function

    function updateHeight() {
      // Calculate the new height here, for example, setting it to window.innerHeight
      const newHeight = window.innerHeight;
      self.style.height = newHeight + "px";

      // Request the next animation frame
      self.animationFrameId = requestAnimationFrame(updateHeight);
    }

    // Start the animation loop
    this.animationFrameId = requestAnimationFrame(updateHeight);
  }

  stopAnimationLoop() {
    // Cancel the animation frame when the element is removed
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "mobile-cart-icon-bubble",
        section: "mobile-cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("mini-cart", MiniCart);
